import React from "react"
import { useTranslation } from "react-i18next"

import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"

import { Diagram } from "./components/Diagram/Diagram"
import styles from "./index.module.css"

export const Structure: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.Wrapper}>
      <div className="container">
        <Heading as="div" className={styles.Title} like="h1">
          <Raw html={t("stock.Structure.Title")} />
        </Heading>

        <Diagram />
      </div>
    </div>
  )
}
